//Actions
import {
  SET_TABLE_PREFERENCE,
  SET_TABLE_PREFERENCE_SAVING,
  LOGOUT,
} from '~/redux/actions/action-types';

// Visible columns by screen: { [screen]: { visibleColumns, loaded, saving } }.
const initialState = {
  screens: {},
};

const tablePreferencesReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TABLE_PREFERENCE:
      return {
        ...state,
        screens: {
          ...state.screens,
          [payload.screen]: {
            ...state.screens[payload.screen],
            visibleColumns: payload.visibleColumns,
            loaded: true,
          },
        },
      };
    case SET_TABLE_PREFERENCE_SAVING:
      return {
        ...state,
        screens: {
          ...state.screens,
          [payload.screen]: { ...state.screens[payload.screen], saving: payload.saving },
        },
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { tablePreferencesReducers };
